// extracted by mini-css-extract-plugin
module.exports = {"container":"details_container_1IKuI","description":"details_description_7nDCe","lore":"details_lore_1vqcR"};